import { Component } from '@theme/component';
import { RecentlyViewed } from '@theme/recently-viewed-products';
import { sectionRenderer } from '@theme/section-renderer';

/** @extends {Component<{grid: HTMLElement}>} */
class TappleRecentlyViewed extends Component {
  requiredRefs = ['grid'];
  #controller;

  connectedCallback() {
    super.connectedCallback();
    this.#controller?.abort();
    this.#controller = new AbortController();
    this.#load(this.#controller.signal);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.#controller?.abort();
  }

  async #load(signal) {
    const ids = RecentlyViewed.getProducts().filter((id) => id !== this.dataset.currentProduct);
    if (!ids.length) return;
    const url = new URL(this.dataset.searchUrl, window.location.origin);
    url.searchParams.set('q', ids.map((id) => `id:${id}`).join(' OR '));
    url.searchParams.set('type', 'product');
    url.searchParams.set('options[unavailable_products]', 'show');
    try {
      const html = await sectionRenderer.getSectionHTML('tapple-recently-viewed', false, url, signal);
      if (signal.aborted || !this.isConnected) return;
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const cards = new Map([...doc.querySelectorAll('.tt-product-card[data-product-id]')].map((card) => [card.dataset.productId, card]));
      const ordered = ids.map((id) => cards.get(id)).filter(Boolean).slice(0, 4);
      // Rendered cards use current prices, availability and native product forms.
      this.refs.grid.replaceChildren(...ordered);
      this.hidden = ordered.length === 0;
    } catch {
      // An optional discovery section must never interrupt shopping.
      if (!signal.aborted) this.hidden = true;
    }
  }

  clearHistory() {
    this.#controller?.abort();
    RecentlyViewed.clearProducts();
    this.hidden = true;
    this.refs.grid.replaceChildren();
  }
}

if (!customElements.get('tapple-recently-viewed')) {
  customElements.define('tapple-recently-viewed', TappleRecentlyViewed);
}
